import { render, staticRenderFns } from "./AttributeIconPreview.vue?vue&type=template&id=4166f144"
import script from "./AttributeIconPreview.vue?vue&type=script&lang=js"
export * from "./AttributeIconPreview.vue?vue&type=script&lang=js"
import style0 from "./AttributeIconPreview.vue?vue&type=style&index=0&id=4166f144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports